import React from 'react'
import { I18nConsumer } from '../i18n-provider'
import { FormattedMessage } from 'react-intl'
import { css, cx } from '@emotion/css'
import { VulnerabilitySeverityBadge } from '.'
import { badgeCss, metadataCss } from '../../legacy-design-system/text'
import { Dropdown } from '../../legacy-design-system/dropdown'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { Severity } from '../vulnerability-severity'

interface Props {
  readonly selectedSeverity: Severity
  readonly defaultSeverity: Severity
  readonly onChange: (severity: Severity) => void
}

export function VulnerabilitySeverityDropdown({
  selectedSeverity,
  defaultSeverity,
  onChange
}: Props) {
  const orderedSeverities = [
    Severity.CRITICAL,
    Severity.HIGH,
    Severity.MEDIUM,
    Severity.LOW,
    Severity.NOTE
  ]
  return (
    <I18nConsumer>
      {({ intl }) => {
        return (
          <Dropdown<Severity>
            onChange={onChange}
            items={orderedSeverities}
            selectedItem={selectedSeverity}
            itemToString={(severity) =>
              intl.formatMessage({ id: severity.i18nID })
            }
            selectionToggleRenderer={({ getToggleButtonProps }) => {
              return (
                <div {...getToggleButtonProps()}>
                  <VulnerabilitySeverityBadge severity={selectedSeverity} />
                </div>
              )
            }}
            menuItemRenderer={({ item }) => {
              return (
                <FormattedMessage id={item.i18nID}>
                  {(text) => {
                    return (
                      <div>
                        <div
                          className={cx(
                            badgeCss,
                            css`
                              color: ${theme.color.neutral90};
                            `
                          )}
                        >
                          {text}
                        </div>
                        {item === defaultSeverity && (
                          <FormattedMessage id="detail_vulnerabilityTrace_default_severityType">
                            {(text) => {
                              return (
                                <div
                                  className={cx(
                                    metadataCss,
                                    css`
                                      line-height: 11px;
                                      font-size: 10px;
                                    `
                                  )}
                                >
                                  {text}
                                </div>
                              )
                            }}
                          </FormattedMessage>
                        )}
                      </div>
                    )
                  }}
                </FormattedMessage>
              )
            }}
            styleOverrides={{
              outerContainerCss: css`
                width: initial;
              `
            }}
          />
        )
      }}
    </I18nConsumer>
  )
}
